import { UUID } from '@hc-frontend/core-types';
import z from 'zod';

import { FeaturedAd } from './featured-ad';

export const FeaturedAds = z.object({
  id: UUID,
  searchMethod: z.string(),
  segmentationFit: z.string(),
  result: z.array(FeaturedAd).min(1),
});

export type FeaturedAds = z.infer<typeof FeaturedAds>;
